var _ellipse, _path, _path2, _ellipse2, _path3, _path4, _ellipse3, _path5, _path6, _ellipse4, _path7, _path8, _ellipse5, _path9, _path0, _ellipse6, _path1, _path10, _ellipse7, _path11, _path12, _ellipse8, _path13, _path14, _ellipse9, _path15, _path16, _ellipse0, _path17, _path18, _ellipse1, _path19, _path20, _ellipse10, _path21, _path22, _ellipse11, _path23, _path24, _ellipse12, _path25, _path26, _ellipse13, _path27, _path28, _ellipse14, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse15, _ellipse16, _ellipse17, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _ellipse18, _ellipse19, _path48, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 500,
    viewBox: "0 0 800 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-614.906 -441.671)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.23,
    cy: 41.642,
    rx: 39.23,
    ry: 41.642,
    transform: "translate(918.975 777.34)",
    fill: "#f59e0b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M605.491,749.471,601.41,747.2s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C686.142,744.18,605.491,749.471,605.491,749.471Z",
    transform: "translate(375.375 107.275)",
    fill: "#f59e0b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605.491,749.471,601.41,747.2s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C686.142,744.18,605.491,749.471,605.491,749.471Z",
    transform: "translate(375.375 107.275)",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(976.785 844.794)",
    fill: "#f59e0b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M621.2,735.8l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.263,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C701.848,730.508,621.2,735.8,621.2,735.8Z",
    transform: "translate(376.075 106.717)",
    fill: "#f59e0b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M621.2,735.8l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.263,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C701.848,730.508,621.2,735.8,621.2,735.8Z",
    transform: "translate(376.075 106.717)",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(993.191 830.572)",
    fill: "#f59e0b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M635.081,717.83,631,715.558s-1.909,7.965-1.285,13.641a2.827,2.827,0,0,0,2.125,2.443c9.388,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C715.733,712.54,635.081,717.83,635.081,717.83Z",
    transform: "translate(376.693 105.928)",
    fill: "#f59e0b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M635.081,717.83,631,715.558s-1.909,7.965-1.285,13.641a2.827,2.827,0,0,0,2.125,2.443c9.388,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C715.733,712.54,635.081,717.83,635.081,717.83Z",
    transform: "translate(376.693 105.928)",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1007.694 811.814)",
    fill: "#f59e0b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M619.7,699.125l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726A2.823,2.823,0,0,0,703,708.942c.377-3.488-.959-10.687-1.492-12.089C700.356,693.834,619.7,699.125,619.7,699.125Z",
    transform: "translate(376.008 105.107)",
    fill: "#f59e0b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M619.7,699.125l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726A2.823,2.823,0,0,0,703,708.942c.377-3.488-.959-10.687-1.492-12.089C700.356,693.834,619.7,699.125,619.7,699.125Z",
    transform: "translate(376.008 105.107)",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(991.633 792.288)",
    fill: "#f59e0b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M654.3,684.114l-4.081-2.272s-1.909,7.965-1.285,13.641a2.827,2.827,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C734.947,678.823,654.3,684.114,654.3,684.114Z",
    transform: "translate(377.55 104.449)",
    fill: "#f59e0b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M654.3,684.114l-4.081-2.272s-1.909,7.965-1.285,13.641a2.827,2.827,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C734.947,678.823,654.3,684.114,654.3,684.114Z",
    transform: "translate(377.55 104.449)",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1027.765 776.618)",
    fill: "#f59e0b"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M630.925,674.024l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C711.576,668.734,630.925,674.024,630.925,674.024Z",
    transform: "translate(376.508 104.006)",
    fill: "#f59e0b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M630.925,674.024l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C711.576,668.734,630.925,674.024,630.925,674.024Z",
    transform: "translate(376.508 104.006)",
    opacity: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1003.352 766.086)",
    fill: "#f59e0b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M646.528,654.546l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C727.18,649.255,646.528,654.546,646.528,654.546Z",
    transform: "translate(377.204 103.151)",
    fill: "#f59e0b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M646.528,654.546l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C727.18,649.255,646.528,654.546,646.528,654.546Z",
    transform: "translate(377.204 103.151)",
    opacity: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1019.651 745.753)",
    fill: "#f59e0b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M654.225,631.426l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C734.876,626.136,654.225,631.426,654.225,631.426Z",
    transform: "translate(377.546 102.137)",
    fill: "#f59e0b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M654.225,631.426l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C734.876,626.136,654.225,631.426,654.225,631.426Z",
    transform: "translate(617.794 102.137)",
    opacity: 0.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1027.691 721.618)",
    fill: "#f59e0b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M723.62,754.833l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C804.271,749.542,723.62,754.833,723.62,754.833Z",
    transform: "translate(380.638 107.514)",
    fill: "#f59e0b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M723.62,754.833l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C804.271,749.542,723.62,754.833,723.62,754.833Z",
    transform: "translate(380.638 107.514)",
    opacity: 0.1
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1100.177 850.396)",
    fill: "#f59e0b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M737.5,736.864l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.263,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C818.156,731.574,737.5,736.864,737.5,736.864Z",
    transform: "translate(381.257 106.764)",
    fill: "#f59e0b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M737.5,736.864l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.263,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C818.156,731.574,737.5,736.864,737.5,736.864Z",
    transform: "translate(381.257 106.764)",
    opacity: 0.1
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1114.68 831.684)",
    fill: "#f59e0b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M722.128,718.159l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C802.78,712.868,722.128,718.159,722.128,718.159Z",
    transform: "translate(380.572 105.943)",
    fill: "#f59e0b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M722.128,718.159l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C802.78,712.868,722.128,718.159,722.128,718.159Z",
    transform: "translate(380.572 105.943)",
    opacity: 0.1
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1098.619 812.157)",
    fill: "#f59e0b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M756.719,703.147l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.263,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C837.371,697.857,756.719,703.147,756.719,703.147Z",
    transform: "translate(382.113 105.284)",
    fill: "#f59e0b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M756.719,703.147l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.263,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C837.371,697.857,756.719,703.147,756.719,703.147Z",
    transform: "translate(382.113 105.284)",
    opacity: 0.1
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1134.751 796.487)",
    fill: "#fbd56f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M733.348,693.058l-4.081-2.272s-1.909,7.965-1.285,13.641a2.827,2.827,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C814,687.768,733.348,693.058,733.348,693.058Z",
    transform: "translate(381.072 104.841)",
    fill: "#f59e0b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M733.348,693.058l-4.081-2.272s-1.909,7.965-1.285,13.641a2.827,2.827,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C814,687.768,733.348,693.058,733.348,693.058Z",
    transform: "translate(381.072 104.841)",
    opacity: 0.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1110.339 785.955)",
    fill: "#f59e0b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M748.952,673.58l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C829.6,668.289,748.952,673.58,748.952,673.58Z",
    transform: "translate(381.767 103.986)",
    fill: "#f59e0b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M748.952,673.58l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C829.6,668.289,748.952,673.58,748.952,673.58Z",
    transform: "translate(381.767 103.986)",
    opacity: 0.1
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1126.637 765.622)",
    fill: "#f59e0b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M756.648,650.46l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C837.3,645.169,756.648,650.46,756.648,650.46Z",
    transform: "translate(382.11 102.972)",
    fill: "#f59e0b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M756.648,650.46l-4.081-2.272s-1.909,7.965-1.285,13.641a2.828,2.828,0,0,0,2.125,2.443c9.387,2.331,54.129,12.264,84.9-1.726a2.823,2.823,0,0,0,1.635-2.269c.377-3.488-.959-10.687-1.492-12.089C837.3,645.169,756.648,650.46,756.648,650.46Z",
    transform: "translate(382.11 102.972)",
    opacity: 0.1
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.94,
    cy: 9.679,
    rx: 42.94,
    ry: 9.679,
    transform: "translate(1134.678 741.487)",
    fill: "#fbd56f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M923.171,818.119v12.115s57.86,1.044,70.6,1.044,30.288-6.267,31.332-11.28-14.622-9.191-20.47-9.4-6.058-2.507-13.577-6.475c-4.244-2.239-17.128-5.464-21.933-10.7-3.706-4.04,0-10.607,0-10.607s-6.247-.126-14.232.2c-9.211.373-20.916,1.422-25.874,4.189-2.068,1.157-3.5,3.421-4.466,6.221C921.316,802.779,923.171,818.119,923.171,818.119Z",
    transform: "translate(389.75 108.902)",
    fill: "#090814"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M924.472,793.425c6.525-2.268,44.73-3.15,51.009-3.279-3.706-4.04-6.438-7.328-6.438-7.328s-31.124-.627-40.106,4.387C926.87,788.361,925.441,790.626,924.472,793.425Z",
    transform: "translate(389.832 108.902)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M763.77,608.4s1.207.731,3.376,2.039c.393.234.815.493,1.266.765,1.374.831,3.025,1.821,4.909,2.958,26.252,15.821,97.866,58.708,101.784,58.366,1.028-.088,4.115-.551,8.376-1.245,1.128-.184,2.339-.38,3.618-.6,16.4-2.724,43.656-7.649,46.7-9.02,4.178-1.88,3.342,6.475,1.671,13.577s-5.415,135.92-5.415,135.92c6.684-2.506,50.1-6.128,50.1-6.128s5.026-125.2,5.444-157.573-18.382-33.421-18.382-33.421-37.829-5.241-39.479-5.778c-10.235-3.484-44.7-3.622-50.341-1.115a15.147,15.147,0,0,1-11.255.013l-.025-.013-4.387-7.1-41.9,3.572-4.441.38-41.246,3.518-2.837.242Z",
    transform: "translate(382.672 100.76)",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M889.553,503.528a12.759,12.759,0,0,0,1.475,4.086c4.458,9.128,24.709,33.592,27.142,37.482,3.551,6.058,12.533,51.8,16.293,56.189,1.88,2.193-5.194,7.861-6.851,10.427-5.477,8.806-14.221,26.273-1.922,32.268,16.711,8.146,32.377-34.549,32.377-34.549s-3.133-30.288-3.969-35.51-5.849-26.737-5.849-26.737-3.551-9.191-5.64-15.666-31.75-48.461-31.75-48.461S889.344,498.514,889.553,503.528Z",
    transform: "translate(388.276 95.73)",
    fill: "#ed9da0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M753.971,816.182,791.988,833.1s49.3,1.044,57.86-1.253,6.684-11.906-4.6-13.786-14-6.893-17.755-9.191c-2.536-1.55-11.543-11.568-17.133-17.918-2.69-3.058-4.591-5.268-4.591-5.268s-7.311-19.426-27.573-15.04a20.762,20.762,0,0,0-9.859,5.189c-10.916,10.106-11.865,30.112-11.865,30.112Z",
    transform: "translate(382.235 108.332)",
    fill: "#090814"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M768.213,611.235c1.375.831,3.025,1.821,4.909,2.958,26.252,15.821,97.866,58.708,101.784,58.366,1.028-.088,4.115-.551,8.376-1.245,1.128-.184,2.339-.38,3.618-.6.05-.079.1-.159.142-.238a48.019,48.019,0,0,0,4.783-11.706c4.387-16.711-17.337-29.452-17.337-29.452l-4.6-3.572c-5.222-8.794-42.821-17.108-42.821-17.108l-4.846-3.254-2.586-1.738-.681-.455-5.882-3.952-29.453,2.089-8.748,5.623-.923.593-3.246,2.089Z",
    transform: "translate(382.87 100.845)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M767.729,775.834c8,27.656,41.4,18.624,41.4,18.624l.622-3.505c-2.69-3.058-4.591-5.268-4.591-5.268s-7.311-19.426-27.572-15.04A20.762,20.762,0,0,0,767.729,775.834Z",
    transform: "translate(382.848 108.332)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M759.753,657.9c12.324,0,59.323,18.173,59.323,18.173l-23.813,39.27-31.038,65.331c2.089,39.9,45.66,19.684,45.66,19.684,4.178-10.653,71.4-124.057,74.174-129.081a48.012,48.012,0,0,0,4.783-11.706c3.534-13.456-9.867-24.343-15.219-28.065-1.3-.9-2.118-1.387-2.118-1.387l-4.6-3.572c-2.373-4-11.447-7.9-20.633-10.962-6.626-2.21-13.314-3.986-17.588-5.051-2.828-.7-4.6-1.095-4.6-1.095l-4.846-3.254-1.7-1.145-1.562-1.049-5.882-3.952-13.105.928-16.347,1.161-8.748,5.623-4.169,2.682L751.4,620.93s-.43,4.019-.568,9.412c-.008.418-.017.84-.025,1.274C750.633,642.536,751.807,657.9,759.753,657.9Z",
    transform: "translate(382.093 100.76)",
    fill: "#e6e6e6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M819.562,432.33,823.949,448s7.729,26.946,8.564,28.826,21.1,20.888,21.933,21.306,11.869,6.684,11.869,6.684.873-34.466.038-44.492a28.625,28.625,0,0,1,.543-6.567c1.333-7.858,4.7-19.38,7.5-28.253,2.34-7.436,4.282-13.013,4.282-13.013S829.8,410.4,831.469,415.2c.631,1.817.426,4.854-.184,7.9-1.007,5.009-3.112,10.035-4.412,9.646a17.488,17.488,0,0,0-3.873-.43C821.2,432.263,819.562,432.33,819.562,432.33Z",
    transform: "translate(385.157 92.689)",
    fill: "#ed9da0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M750.846,637.91v0c4.207-2.979,8.2-7.035,10.595-8.159,3.551-1.671,8.982-7.1,8.982-7.1s11.071-7.52,18.591-8.146c2.051-.171,6.337-.468,11.489-.8,5.272-.351,11.443-.744,17.053-1.09,3.234-.2,6.279-.4,8.853-.556l7.724-.476s13.433-2.657,19.281.476c4.189,2.1,8.749,1.563,13.3,2.657l5.849-37.808s1.88-15.248,3.76-22.142,9.191-45.328,12.951-47.834,5.849,1.88,5.849,1.88,25.066-.418,25.484-27.99c0,0-30.706-40.105-37.808-40.314a57.142,57.142,0,0,0-10.06.309l-6.024,24.548-1.88,25.9s-13.368-12.951-15.457-18.382-9.609-15.265-9.609-15.265-8.564-14.4-8.773-16.9-6.057-9.224-6.057-9.224a15.248,15.248,0,0,0-3.551,0,3.8,3.8,0,0,1-1.554-.217,20.918,20.918,0,0,0-10.436-.593c-7.223,1.5-18.21,4.244-21.222,7.528-4.6,5.013-11.28,9.818-18.8,30.706L809.9,483.529l-3.467,6.592-32.251,61.294s-1.07,1.742-2.519,4.019v0c-1.88,2.954-12.52,42.14-17.952,62.4C753.712,617.84,749.014,639.313,750.846,637.91Z",
    transform: "translate(382.077 93.416)",
    fill: "#f59e0b"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M808.172,491.612s-6.266,43.865-3.76,45.745,10.043,40.732,10.043,40.732L830.639,620.7s50.642-5.013,45.42,10.862-47,12.533-47,12.533L813.6,630.519s-20.888-31.541-22.977-33.839-18.591-40.941-18.591-40.941-9.609-72.9-5.013-78.958S803.368,473.44,808.172,491.612Z",
    transform: "translate(382.761 95.326)",
    fill: "#ed9da0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M781.871,459.783l-13.16,7.938-3.322,13.815s22.957-14.024,42.8,19.606c0,0-.627-4.387,2.089-6.475s2.089-11.071,2.089-11.071a36.187,36.187,0,0,0,1.88-4.386C816.127,474.614,806.31,448.294,781.871,459.783Z",
    transform: "translate(382.744 94.615)",
    fill: "#f59e0b"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.23,
    cy: 41.642,
    rx: 39.23,
    ry: 41.642,
    transform: "translate(1008.092 836.692)",
    fill: "#f59e0b"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.23,
    cy: 41.642,
    rx: 39.23,
    ry: 41.642,
    transform: "translate(1008.092 836.692)",
    opacity: 0.1
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.23,
    cy: 40.714,
    rx: 39.23,
    ry: 40.714,
    transform: "translate(1014.863 838.546)",
    fill: "#f59e0b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614.906 678.727)"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M528.422,729.543a20.86,20.86,0,0,1,2.594,4.737c.173.436.343.893.5,1.373,2.579,7.706-1.507,16.947-2.675,15.95s-17.84,4.625-20.654-.694a51.516,51.516,0,0,1-2.448-5.41c-.625-1.633-.984-2.762-.984-2.762l19.729-16.81A11.679,11.679,0,0,1,528.422,729.543Z",
    transform: "translate(-318.053 -504.259)",
    fill: "#e6e6e6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M468.158,750.375a20.864,20.864,0,0,1,2.594,4.737c.173.436.343.893.5,1.373,2.578,7.706-1.507,16.947-2.675,15.95s-17.84,4.625-20.654-.694a51.535,51.535,0,0,1-2.449-5.41c-.625-1.633-.984-2.762-.984-2.762l19.729-16.81A11.677,11.677,0,0,1,468.158,750.375Z",
    transform: "translate(-288.884 -514.342)",
    fill: "#e6e6e6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M341.911,777.579a20.863,20.863,0,0,1-1.026,5.3c-.145.446-.306.907-.489,1.379-2.933,7.578-28.925,2.748-27.7-3.143a51.523,51.523,0,0,1,1.568-5.728c.561-1.656,1.005-2.754,1.005-2.754l25.917-.35A11.678,11.678,0,0,1,341.911,777.579Z",
    transform: "translate(-225.07 -526.697)",
    fill: "#e6e6e6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.012,761.211a20.865,20.865,0,0,1-1.026,5.3c-.145.446-.306.907-.489,1.379-2.933,7.578-28.925,2.748-27.7-3.143a51.525,51.525,0,0,1,1.568-5.728c.561-1.656,1.005-2.754,1.005-2.754l25.917-.35A11.678,11.678,0,0,1,277.012,761.211Z",
    transform: "translate(-193.657 -518.774)",
    fill: "#e6e6e6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M405.9,428.466c0,69.222-23.417,125.338-131.48,125.338-72.614,0-128.793-18.043-131.48-125.338-1.733-69.2,58.865-125.338,131.48-125.338S405.9,359.244,405.9,428.466Z",
    transform: "translate(-142.906 -299.611)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.994,307.369h.015l-.012,0Z",
    transform: "translate(-243.142 -301.664)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32,307.082c.334-.054.994-.146,1.954-.219l-2.138.253q.046-.012.115-.023Z",
    transform: "translate(-243.211 -301.419)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.493,356.7l-9.6,3.455a214.372,214.372,0,0,0-15.766-18.795,154.019,154.019,0,0,0-19.966-17.885c-24.572-18.211-43.578-18.676-49.855-18.208l14.426-1.7a117.293,117.293,0,0,1,38.73,14,127.95,127.95,0,0,1,23.275,17.194C443.3,346.427,449.493,356.7,449.493,356.7Z",
    transform: "translate(-245.231 -299.827)",
    fill: "#d6d6e3",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.781,368.408s-12.668-42.227-1.919-53.744c0,0,16.891-5.758,29.559,26.872Z",
    transform: "translate(-247.277 -305.005)",
    fill: "#d6d6e3",
    style: {
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M494.962,320.274s33.595-28.548,48.456-23.324c0,0,12.052,13.161-12.752,37.858Z",
    transform: "translate(-313.311 -296.311)",
    fill: "#d6d6e3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M590.606,528.134c0,28.192-20.231,50.464-39.266,50.464s-29.668-22.272-29.668-50.464,15.463-49.944,34.467-51.046C586.243,475.343,590.606,499.942,590.606,528.134Z",
    transform: "translate(-302.584 -378.872)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M590.606,528.134c0,28.192-20.231,50.464-39.266,50.464s-29.668-22.272-29.668-50.464,15.463-49.944,34.467-51.046C586.243,475.343,590.606,499.942,590.606,528.134Z",
    transform: "translate(-302.585 -378.872)",
    fill: "#d6d6e3",
    style: {
      isolation: "isolate"
    }
  }), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.245,
    cy: 6.676,
    rx: 5.245,
    ry: 6.676,
    transform: "translate(245.109 145.112)",
    fill: "#e6e6e6"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.245,
    cy: 6.676,
    rx: 5.245,
    ry: 6.676,
    transform: "translate(263.706 139.39)",
    fill: "#e6e6e6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M479.148,336.558a15.326,15.326,0,0,1-1.639,6.933,14.732,14.732,0,0,1-6.61,6.6A154.017,154.017,0,0,0,450.932,332.2a15.046,15.046,0,0,1,3.3-5.9,14.153,14.153,0,0,1,10.5-4.7A14.7,14.7,0,0,1,479.148,336.558Z",
    transform: "translate(-291.999 -308.549)",
    fill: "#f59e0b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1202.119 441.671)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.979,
    cy: 38.979,
    rx: 38.979,
    ry: 38.979,
    transform: "translate(5.937 10.042)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.6,204.929c2.147.366,4.668-4.838,7.076-9.907,5.042-10.61,8.247-17.355,8.491-26.889.208-8.126-2.05-5.993-4.246-24.059-.724-5.959-10.9-5.947-12.976-8.777-3.5-4.779,1.87-6.75-6.837-9.621-16.309-5.378-23.684,2.976-34.042,3.7-.262.018-5.4,5.04-8.264,5.3-5.024.455-12.272-.328-15.522-7.983-3.038-7.158-5.051,13.758-2.335,16.347a55,55,0,0,1,6.384,8.115c.044.174,0-5.78,0-5.78s-10.069-2.7-11.055,0c-1.15,3.145,2.47,19.324,5.394,19.932,2.445.508,8.425-7.551,7.076-4.246-3.129,7.666,15.686,12.557,38.211-2.83.8-.546.044.325,2.83,7.076,3.514,8.515,4.307,8.977,4.246,11.322-.133,5.077-3.945,6.572-2.83,9.907.9,2.7,4.429,4.792,7.076,4.246,2.987-.616,3.5-4.311,5.661-4.246,1.852.056,4.05,2.846,4.246,5.661.412,5.931-8.368,7.562-9.907,15.568-.868,4.518,9.349-3.167,11.322-2.83Z",
    transform: "translate(-356.056 -123.882)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.4d697b012c68151db8f971c17fadae5d.svg";
export { ForwardRef as ReactComponent };